<template>
  <component v-bind="$attrs" :is="variant" v-if="showBanner" :public-path="PUBLIC_PATH" />
</template>
<script setup lang="ts">
import BannerBoxDesktop from '@/components/widgets/BannerBox/variants/BannerBoxDesktop.vue'
import BannerBoxMobile from '@/components/widgets/BannerBox/variants/BannerBoxMobile.vue'
import type { EditionStageType } from '@/types/backend'
import { EditionStage } from '@/types/backend'
import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints'
import { computed } from 'vue'
import useEditionStageStore from '@/stores/EditionStage'
import { storeToRefs } from 'pinia'

type Props = {
  homeStatesToShow?: EditionStageType[]
}

const props = withDefaults(defineProps<Props>(), {
  homeStatesToShow: () => Object.values(EditionStage)
})

const PUBLIC_PATH: string = import.meta.env.VITE_PUBLIC_PATH ?? '/'

const editionStageStore = useEditionStageStore()

const { editionStage } = storeToRefs(editionStageStore)

const showBanner = computed<boolean>(() =>
  editionStage.value ? props.homeStatesToShow.includes(editionStage.value) : false
)

const breakpoints = useVuetifyBreakpoints()
const isMobile = breakpoints.smallerOrEqual('md')

type Variant = typeof BannerBoxDesktop | typeof BannerBoxMobile
const variant = computed<Variant>(() => (isMobile.value ? BannerBoxMobile : BannerBoxDesktop))
</script>
